import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import * as types from './mutation-types';

export function fetchCardForNewClass({ dispatch }, { cardId, cardType }) {
  return http
    .get(`${MINERVA_API_URL}/${cardType}/${cardId}`)
    .then((resp) => {
      dispatch('setCardForNewClass', resp.data);
      dispatch('fetchPageListForNewClass', { cardId, cardType });
    })
    .catch(err => Promise.reject(err));
}

export function setCardForNewClass({ commit }, card) {
  commit(types.SET_CARD_FOR_NEW_CLASS, card);

  return Promise.resolve(card);
}

export function setCurrentPageForNewClass({ commit, state }, index) {
  const pageList = state.newClassPages;
  commit(types.SET_CURRENT_PAGE_FOR_NEW_CLASS, pageList[index]);
  return Promise.resolve(pageList[index]);
}

export function setPageListForNewClass({ commit }, pageList) {
  commit(types.SET_PAGE_LIST_FOR_NEW_CLASS, pageList);

  return Promise.resolve(pageList);
}

export function setPagesPaginationForNewClass({ commit }, pagination) {
  commit(types.SET_PAGINATION_FOR_NEW_CLASS, pagination);

  return Promise.resolve(pagination);
}

export function fetchPageListForNewClass({ dispatch }, { cardId, cardType }) {
  return http
    .get(`${MINERVA_API_URL}/${cardType}/${cardId}/pages`)
    .then((resp) => {
      dispatch('setPageListForNewClass', resp.data);
    });
}

export function fetchPagesPaginationForNewClass({ dispatch }, { page, total }) {
  const perPage = 1;

  dispatch('setPagesPaginationForNewClass', {
    total: Number(total),
    totalPages: Number(total) / Number(perPage),
    page: Number(page),
    perPage: Number(perPage),
  });
}

export function saveQuizValueForNewClass({ commit }, { quizId, value }) {
  return commit(types.SET_QUIZ_VALUE_FOR_NEW_CLASS, { quizId, value });
}

export function saveQuizOptionForNewClass({ commit }, { quizId, option, index }) {
  const indexAddedOption = { ...option, optionIndex: index + 1 };
  return commit(types.SET_QUIZ_OPTION_FOR_NEW_CLASS, { quizId, option: indexAddedOption });
}

export function setPageResultForNewClass({ commit }, { pageId, pageIndex, pageType, essay, multipleChoiceOption, textEntry, maxPoints, isCorrect, duration, correctOptions }) {
  return commit(types.SET_PAGE_RESULT_FOR_NEW_CLASS, { pageId, pageIndex, pageType, essay, multipleChoiceOption, textEntry, maxPoints, isCorrect, duration, correctOptions });
}

export function setAllPagesResultForNewClass({ commit }, results) {
  return commit(types.SET_ALL_PAGE_RESULT_FOR_NEW_CLASS, results);
}

export function resetSelectedOptionsForNewClass({ commit }) {
  commit(types.RESET_SELECT_OPTIONS_FOR_NEW_CLASS);
}

export function resetEnteredValueForNewClass({ commit }) {
  commit(types.RESET_ENTERED_VALUE_FOR_NEW_CLASS);
}

export function saveGradingStatusForNewClass({ commit }, isGraded) {
  commit(types.SAVE_GRADING_STATUS_FOR_NEW_CLASS, isGraded);
}
